/* PDP "Delivery & Stores" composite (Figma). Loaded from sections/main-product.liquid.
   Presentation layer only. It reuses, and never replaces:
   - ClickPost EDD app block (.clickpost-edd__*)      -> ETA text
   - window.pin_check(pin) in sections/header.liquid  -> location_store / pin persistence
   - store cards rendered by store-locator.js         -> decorated in place (classes/handlers intact)
   Mobile-only visuals (CSS gates at max-width:750px). */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('template-product')) return;

  var readLS = function (key) {
    try {
      return window.KushalsStorageTTL ? window.KushalsStorageTTL.get(key) : localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  };
  var getLocation = function () {
    try {
      var parsed = JSON.parse(readLS('location_store') || 'null');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  };
  var liveCustomerLocation = null;
  var normPin = function (v) {
    return String(v || '').replace(/\D/g, '').slice(0, 6);
  };
  // Prefer the explicit pincode, but keep the PDP ClickPost field in sync with the pincode
  // currently shown in the header's `.ct_location`. The header persists that value as
  // location_store.postal, including when it came from auto-detect. The field remains editable
  // through the existing Change flow.
  var currentPin = function () {
    var explicitPin = normPin(readLS('pin'));
    if (explicitPin.length === 6) return explicitPin;

    var locationPin = normPin(getLocation().postal);
    if (locationPin.length === 6) return locationPin;

    // Fallback for the brief period where the header has rendered `.ct_location` but its
    // localStorage write has not completed yet.
    var headerPin = document.querySelector('.ct_location .ct_pincode');
    return headerPin ? normPin(headerPin.textContent) : '';
  };

  /* ---------------- Delivery (ClickPost app block) ---------------- */
  function initDelivery() {
    var c = document.querySelector('.clickpost-edd__container');
    if (!c || c.dataset.pdpDs === '1') return;
    var form = c.querySelector('.clickpost-edd__form');
    var input = c.querySelector('.clickpost-edd__drop_pincode-input');
    var btn = c.querySelector('.clickpost-edd__submit-button');
    if (!form || !input || !btn) return;
    c.dataset.pdpDs = '1';
    c.classList.add('pdp-ds');

    // Seen on-device: the ClickPost input can come out of the DOM already holding the literal
    // string "undefined" (bold, left-aligned like real typed digits — not the grey placeholder),
    // even though none of our own code ever writes to .value without normPin() first (always a
    // valid 6-digit string or an early return). Whatever sets it — the app's own restore-from-
    // storage logic most likely — clear anything non-numeric here so it can never show through.
    var scrubInput = function () {
      if (!c.classList.contains('pdp-ds--saved') && /\D/.test(input.value)) {
        input.value = '';
      }
    };
    scrubInput();
    // A single init-time check isn't enough — seen recur even after that, meaning whatever writes
    // "undefined" does it asynchronously, after this script's own init already ran. Poll for a
    // short window to catch it whenever it actually lands, instead of guessing the exact timing.
    var scrubTries = 0;
    var scrubTimer = setInterval(function () {
      scrubInput();
      if (++scrubTries >= 15) clearInterval(scrubTimer); // ~4.5s at 300ms, generous but bounded
    }, 300);

    // Own fallback message for the "no pincode yet" state — ClickPost's app has its own similar
    // text but it's injected by the app's own async script and isn't reliably present (seen
    // on-device: sometimes just the bare input+button with nothing explaining what it's for,
    // especially once some OTHER location signal like store-locator.js's geolocation has already
    // set something in localStorage, which appears to make ClickPost skip its own placeholder text
    // without actually resolving a real EDD either). This is CSS-toggled, not JS-toggled — always
    // present, shown only in the entry (not-yet-saved) state, so it's independent of ClickPost's
    // own async load/response timing.
    var fallbackMsg = document.createElement('div');
    fallbackMsg.className = 'pdp-ds-fallback-msg';
    fallbackMsg.textContent = 'To Check Estimated Delivery Details and Stores Near You.';
    form.insertAdjacentElement('afterend', fallbackMsg);

    var saved = document.createElement('div');
    saved.className = 'pdp-ds-saved';
    saved.innerHTML =
      '<div class="pdp-ds-saved__row"><span class="pdp-ds-pin"></span>' +
      '<button type="button" class="pdp-ds-change">Change</button></div>' +
      '<div class="pdp-ds-addr" hidden></div>' +
      '<div class="pdp-ds-eta" hidden></div>';
    fallbackMsg.insertAdjacentElement('afterend', saved);
    var pinEl = saved.querySelector('.pdp-ds-pin');
    var addrEl = saved.querySelector('.pdp-ds-addr');
    var etaEl = saved.querySelector('.pdp-ds-eta');
    var changeBtn = saved.querySelector('.pdp-ds-change');

    var pending = '';
    var auto = false;

    var eddDate = function () {
      var e = c.querySelector('#response-edd');
      var t = e ? e.textContent.replace(/\s+/g, ' ').trim() : '';
      var m = t.match(/\bby\s+(.+)$/i);
      return m ? m[1].trim() : '';
    };

    var lastEta = null;
    var refreshEta = function () {
      var d = eddDate();
      if (d === lastEta) return;
      lastEta = d;
      etaEl.textContent = '';
      if (d) {
        etaEl.classList.remove('pdp-ds-eta--loading');
        etaEl.appendChild(document.createTextNode('Delivered by '));
        var b = document.createElement('b');
        b.textContent = d;
        etaEl.appendChild(b);
        etaEl.hidden = false;
      } else {
        etaEl.classList.add('pdp-ds-eta--loading');
        etaEl.hidden = false;
      }
    };

    var refreshAddr = function () {
      var loc = getLocation();
      var pin = pinEl.textContent;
      var addr = pin && normPin(loc.postal) === pin ? String(loc.full_addr || '') : '';
      addrEl.textContent = addr;
      addrEl.hidden = !addr;
    };

    var showSaved = function (pin) {
      pinEl.textContent = pin;
      refreshAddr();
      refreshEta();
      c.classList.add('pdp-ds--saved');
    };

    var showEntry = function () {
      c.classList.remove('pdp-ds--saved');
      input.value = '';
      try {
        input.focus();
      } catch (e) {}
    };

    // External hook: called by assets/pdp-change-address.js once a NEW pincode/location has
    // already been persisted (via window.pin_check / window.callAPI) elsewhere. Re-syncs this
    // block's own saved-pin display and re-runs the ClickPost EDD lookup for the new pin (ClickPost
    // only reacts to its own input+button, it does not watch location_store).
    window.__pdpDeliverySetPin = function (pin) {
      pin = normPin(pin);
      if (pin.length !== 6) return;
      showSaved(pin);
      auto = true;
      input.value = pin;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      btn.click();
      auto = false;
    };

    btn.addEventListener('click', function () {
      if (auto) return;
      var pin = normPin(input.value);
      if (pin.length !== 6) return;
      pending = pin;
      if (typeof window.pin_check === 'function') window.pin_check(pin);
    });

    changeBtn.addEventListener('click', showEntry);

    // CSS alone (.clickpost-edd__container .response { display:none !important }, pdp-figma.css)
    // was not enough on-device: the app's "Order Now & Get it by <date>" line (#response-success)
    // kept showing through. It sets its own inline style via JS, and — same tier, both
    // !important — an inline declaration always wins the specificity tie-break over an external
    // stylesheet rule.
    //
    // Round 1 of the JS fix (force the inline style back to none from a MutationObserver attached
    // to the .response nodes found at init) ALSO didn't hold on-device, despite working against a
    // simulated style-mutation in testing. Most likely cause: the app doesn't just mutate the
    // existing #response-success node in place, it replaces it wholesale (removes the old element,
    // inserts a new one) — an observer attached directly to the OLD node would never see that, and
    // a `.response` NodeList captured once at init (querySelectorAll is static, not live) would
    // miss the replacement entirely.
    //
    // Deliberately NOT observing the whole container's subtree — it also contains everything WE
    // write into (.pdp-ds-saved's pinEl/addrEl/etaEl textContent, .hidden toggles), and the
    // original single-node version of this observer already carried a "never observe a subtree we
    // also write into, that loops forever and freezes the tab" warning. Instead: watch the
    // container SHALLOWLY (direct children only, catches the app swapping .response nodes in/out)
    // to know when to re-attach the existing deep per-node watch (style/class/text, scoped to just
    // the .response nodes themselves, same as before) to whatever `.response` elements currently
    // exist — covers both "replaced wholesale" and "mutated in place" without ever watching our own
    // writes.
    var forceHideResponse = function () {
      var nodes = c.querySelectorAll('.response');
      for (var i = 0; i < nodes.length; i++) {
        // Skip the write once already hidden: this is also what the deep per-node watch below
        // observes, so an unconditional write would re-trigger itself forever. A no-op check keeps
        // this idempotent instead of looping.
        if (nodes[i].style.display !== 'none') {
          nodes[i].style.setProperty('display', 'none', 'important');
        }
      }
    };
    var onResponse = function () {
      forceHideResponse();
      if (pending) {
        if (eddDate()) {
          var pin = pending;
          pending = '';
          showSaved(pin);
          setTimeout(refreshAddr, 1200);
          setTimeout(refreshAddr, 3000);
        }
      } else if (c.classList.contains('pdp-ds--saved')) {
        refreshEta();
      }
    };
    var respObserver = new MutationObserver(onResponse);
    var watchResponseNodes = function () {
      forceHideResponse();
      var nodes = c.querySelectorAll('.response');
      for (var i = 0; i < nodes.length; i++) {
        // Re-calling observe() on a node already being observed by this same observer just updates
        // its options in place (no duplicate notifications) — safe to call on every container
        // mutation without tracking which nodes are already watched.
        respObserver.observe(nodes[i], { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
      }
    };
    watchResponseNodes();
    var containerObserver = new MutationObserver(watchResponseNodes);
    containerObserver.observe(c, { childList: true });

    document.addEventListener('storeLocator:storesRendered', function () {
      if (c.classList.contains('pdp-ds--saved')) refreshAddr();
    });

    var pin0 = currentPin();
    if (pin0.length === 6) {
      showSaved(pin0);
      var fire = function () {
        if (eddDate()) return;
        auto = true;
        input.value = pin0;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        btn.click();
        auto = false;
      };
      var start = function () {
        setTimeout(fire, 600);
        setTimeout(fire, 3500);
      };
      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start);
    }
  }

  /* ---------------- Stores (store-locator.js cards) ---------------- */
  var haversineKm = function (lat1, lon1, lat2, lon2) {
    var R = 6371;
    var rad = Math.PI / 180;
    var dLat = (lat2 - lat1) * rad;
    var dLon = (lon2 - lon1) * rad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.sqrt(a));
  };

  var isOpenNow = function (store) {
    try {
      var o = String(store.openingTime || '').split(':').map(Number);
      var cl = String(store.closingTime || '').split(':').map(Number);
      if (o.length < 2 || cl.length < 2 || isNaN(o[0]) || isNaN(cl[0])) return null;
      var now = new Date();
      var open = new Date(now);
      var close = new Date(now);
      open.setHours(o[0], o[1] || 0, 0);
      close.setHours(cl[0], cl[1] || 0, 0);
      if (close <= open) close.setDate(close.getDate() + 1);
      return now >= open && now < close;
    } catch (e) {
      return null;
    }
  };

  var distanceLabel = function (loc, store) {
    var distanceLocation = liveCustomerLocation || loc;
    var uLat = parseFloat(distanceLocation.latitude || distanceLocation.lat);
    var uLon = parseFloat(distanceLocation.longitude || distanceLocation.lan || distanceLocation.lng);
    var sLat = parseFloat(store.latitude);
    var sLon = parseFloat(store.longitude);
    if ([uLat, uLon, sLat, sLon].some(isNaN)) return '';
    var km = haversineKm(uLat, uLon, sLat, sLon);
    var label = km < 0.95
      ? Math.max(10, Math.round((km * 1000) / 10) * 10) + ' m away'
      : km.toFixed(1) + ' km away';
    return label;
  };

  function decorateStores() {
    var box = document.querySelector('.ct_more_store.ct_more_store_product');
    if (!box) return;

    var card = box.querySelector('.store-more-box');
    if (!card) return;
    box.classList.add('pdp-ds-stores');

    // querySelectorAll, not querySelector: desktop shows every nearby store card at once (mobile
    // hides all but the first via CSS), so a single-card rename left later cards saying the theme's
    // default "Reserve This Product" while card 1 said "Reserve Product".
    box.querySelectorAll('.store-more-box button.reserve-product').forEach(function (btn) {
      if (/^\s*reserve this product\s*$/i.test(btn.textContent)) {
        btn.textContent = 'Reserve Product';
      }
    });

    // Out of stock at this store (Figma): "Book Appointment" takes the Reserve Product slot instead of
    // Call Store stretching full-width.
    var invFooter = card.querySelector('.store-inventory-footer');
    if (
      invFooter &&
      invFooter.classList.contains('not-available') &&
      !invFooter.querySelector('button.reserve-product, button.book-appmt-button')
    ) {
      var apptBtn = document.createElement('button');
      apptBtn.type = 'button';
      apptBtn.className = 'book-appmt-button';
      apptBtn.textContent = 'Book Appointment';
      apptBtn.setAttribute('data-product', document.title);
      apptBtn.setAttribute('data-pageTitle', 'Product');
      // User ask (2026-09-25): this card already knows its store, so skip the "Stores Near You" list
      // (step 1) and jump straight to "Selected Store + Pick Date & Time" (the middle modal) — the SAME
      // store-prefilled flow the "Stores Near You" popup's own cards use (switchToLocationModal(),
      // appointment-modal.js ~485), called directly with `card` instead of going through
      // handleAppointmentAction()'s .closest('.appmt-store-box') lookup, since this card is
      // deliberately NOT tagged .appmt-store-box — that class also drives updateStoreButtons()'s "View
      // Appointment" relabeling, out of scope here. Previously this used appointModalOpen() (the SAME
      // popup as the "BOOK APPOINTMENT" banner in Product Description, per an earlier request for
      // visual consistency) — that banner has no specific store to prefill, so it still uses
      // appointModalOpen() unchanged (main-product.liquid ~1760); only this card, which DOES know its
      // store, was switched.
      apptBtn.addEventListener('click', function () {
        switchToLocationModal(card);
      });
      invFooter.appendChild(apptBtn);
    }

    var head = box.querySelector('.store-more-head > span');
    if (head) head.textContent = 'Store Near You';

    // Figma: "IN STOCK" pill top-right of the heading row. State comes from the card's own
    // .store-inventory-footer (store-locator.js adds .not-available when the selected variant isn't
    // stocked there). Re-derived on every render: variant changes re-render the cards.
    var headWrap = box.querySelector('.store-more-head');
    var oldPill = box.querySelector('.pdp-ds-stock');
    if (oldPill) oldPill.remove();
    var inv = card.querySelector('.store-inventory-footer');
    if (headWrap && inv && !inv.classList.contains('not-available')) {
      var pill = document.createElement('span');
      pill.className = 'pdp-ds-stock';
      pill.textContent = 'IN STOCK';
      headWrap.appendChild(pill);
    }

    var loc = getLocation();
    var list = Array.isArray(loc.storeList) ? loc.storeList : [];
    var store = null;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(card.getAttribute('data-store-id'))) {
        store = list[i];
        break;
      }
    }

    if (store) distanceLabel(loc, store);

    if (card.dataset.pdpDs !== '1') {
      card.dataset.pdpDs = '1';
      card.classList.add('pdp-ds-card');
      var inner = card.querySelector('.store-more-box-inner');
      if (inner && store) {
        if (store.image) {
          var photo = document.createElement('div');
          photo.className = 'pdp-ds-photo';
          var img = document.createElement('img');
          img.alt = '';
          img.loading = 'lazy';
          img.src = store.image;
          var badge = document.createElement('span');
          badge.className = 'pdp-ds-photo__g';
          var g = document.createElement('b');
          g.textContent = 'G';
          badge.appendChild(g);
          badge.appendChild(document.createTextNode(' ' + (store.rating || '')));
          photo.appendChild(img);
          if (store.rating) photo.appendChild(badge);
          inner.appendChild(photo);
        }

        var meta = document.createElement('div');
        meta.className = 'pdp-ds-meta';
        var open = isOpenNow(store);
        if (open !== null) {
          var st = document.createElement('span');
          st.className = 'pdp-ds-open' + (open ? '' : ' is-closed');
          st.appendChild(document.createElement('i'));
          st.appendChild(document.createTextNode(open ? 'Open Now' : 'Closed'));
          meta.appendChild(st);
        }
        var dist = distanceLabel(loc, store);
        if (dist && store.direction) {
          var a = document.createElement('a');
          a.className = 'pdp-ds-km ct_store_map';
          a.href = store.direction;
          a.target = '_blank';
          a.rel = 'noopener';
          a.setAttribute('data-store', store.name || '');
          a.textContent = dist;
          meta.appendChild(a);
        }
        inner.appendChild(meta);
      }
    }

    if (!box.querySelector('.pdp-ds-more')) {
      var extra = list.length - 1;
      if (extra > 0) {
        var more = document.createElement('a');
        more.href = '#';
        more.className = 'pdp-ds-more';
        more.textContent = extra + ' More Store' + (extra > 1 ? 's' : '') + ' Near You ';
        var arrow = document.createElement('span');
        arrow.textContent = '→';
        more.appendChild(arrow);
        more.addEventListener('click', function (event) {
          event.preventDefault();
          var va = box.querySelector('.ct-view-all-stores');
          if (va) va.click();
          else if (typeof openAllStoresPopup === 'function') openAllStoresPopup();
        });
        box.appendChild(more);
      }
    }
  }

  function initStores() {
    document.addEventListener('storeLocator:storesRendered', decorateStores);
    decorateStores();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        liveCustomerLocation = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        };
        decorateStores();
      }, function () {}, { enableHighAccuracy: true, maximumAge: 60000, timeout: 10000 });
    }
  }

  var init = function () {
    initDelivery();
    initStores();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
